import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { EnrollmentPropositionLight } from '../../lib/types/models/enrollment/enrollment-light'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getEnrollmentPropositions = async (enrollmentId: number) => {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.enrollments.getPropositions.url, { id: enrollmentId }),
        { version: 'LIGHT' }
      )
    )
    .get<PaginationResponse<EnrollmentPropositionLight>>()
}
